import { TABLES } from "../db";
import { BaseLocalRepository } from "./BaseLocalRepository";

export class LocalTripRepository extends BaseLocalRepository {
  constructor(db) {
    super(db, TABLES.TRIPS);
  }

  async listByVoyageId(voyageId) {
    return this.table.where("voyageId").equals(voyageId).sortBy("sequence");
  }
}
